
/**
 * 
 * @param {HTMLElement} element 
 * @returns string
 * 
 * handleFontWeight gets an element as parameter and based on its innerHTML,
 * it returns a tailwind class.
 * 
 * So calling this method passing a H4 element, for example, coming from shopify's RTF with bold letters, will return the tailwind class "text-h4-bold".
 * 
 * Since we already have the styles in place for each typography class, then it's simply a matter of getting this method's return value and adding to the classlist of the element.
 */
const handleFontWeight = (element) => {
  const innerHTML = element.innerHTML;
  const elementTag = element.tagName.toLowerCase();

  if (innerHTML.includes('<strong>')) return `text-${elementTag}-bold`;
  else return `text-${elementTag}-regular`;
};

const handleBreakline = (element) => {
  return element.innerHTML === '' || element.innerHTML.trim() === '&nbsp;'
}

const redirect = (url) => {
  window.location.href = url;
}

const handleBlockquote = (query) => {
  const blockquote = query ? document.querySelectorAll(query) : document.querySelectorAll('.blockquote');
  if (blockquote.length === 0) return

  blockquote.forEach(entry => {
    Array.from(entry.children).forEach(child => {
      let test = child;

      while (test.childElementCount > 0) {
        test = test.children[0];
      }

      const q = document.createElement('q');
      const citation = entry.getAttribute('data-cite');
      q.setAttribute('cite', citation);
      q.innerHTML = test.innerHTML;
      child.innerHTML = '';
      child.appendChild(q);
    });
  });
}

const handleRTF = (query) => {
  const rtf = query ? document.querySelectorAll(query) : document.querySelectorAll('.rtf');
  if (rtf.length === 0) return

  rtf.forEach((entry) => {
    let rtfEntry = entry;
    for (let i = 0; i < rtfEntry.children.length; i++) {
      const child = rtfEntry.children[i];
      const isBreakline = handleBreakline(child);
      if (isBreakline) {
        const breakline = document.createElement('br');
        child.appendChild(breakline);
        continue;
      }
      switch (child.tagName) {
        case 'H1':
          child.classList.add('text-h1');
          break;
        case 'H2':
          child.classList.add('text-h2');
          break;
        case 'H3':
          child.classList.add('text-h3');
          break;
        case 'H4':
          child.classList.add(handleFontWeight(child));
          break;
        case 'H5':
          child.classList.add(handleFontWeight(child));
          break;
        case 'H6':
          child.classList.add(handleFontWeight(child));
          break;
        case 'P':
          const isBold = handleFontWeight(child);
          if (isBold.includes('bold')) {
            child.classList.add(isBold, 'font-futura-heavy');
          } else {
            child.classList.add(isBold);
          }
        default:
          break;
      }
    }
  });
};

const playVideos = () => {
  const videos = document.querySelectorAll('.video-container');
  if (videos.length === 0) return;
  videos.forEach(videoContainer => {
    const [video] = videoContainer.getElementsByTagName('video')
    video.classList.add('aspect-horizontal-media', 'object-cover')
    video.muted = true;
    video.loop = true;
    video.controls = true;
    try {
      video.play();
    } catch (e) {
      console.error(e);
    }
  })
}

let debounceTimeout = null;
const debounce = (func, delay) => {
  return (...args) => {
    clearTimeout(debounceTimeout);
    debounceTimeout = setTimeout(() => { func.apply(this, args); debounceTimeout = null; }, delay);
  };
};